export const HOTEL_DINING_CAROUSEL_FLAG_KEY = 'hotel_dining_carousel_test';
export const NIGHTLY_RATES_CALENDAR_FLAG_KEY = 'tl698_nightly_rates_calendar';
export const TL709_ROOMS_RECOMMENDED_FOR_YOU_FLAG_KEY = 'tl709_rooms_recommended_for_you';

export const EXPERIMENT_FLAG_KEYS = [
	HOTEL_DINING_CAROUSEL_FLAG_KEY,
	NIGHTLY_RATES_CALENDAR_FLAG_KEY,
	TL709_ROOMS_RECOMMENDED_FOR_YOU_FLAG_KEY,
] as const;
